import { render, staticRenderFns } from "./FiltersSwitcherBtn.vue?vue&type=template&id=7a5596d0&scoped=true&"
import script from "./FiltersSwitcherBtn.vue?vue&type=script&lang=js&"
export * from "./FiltersSwitcherBtn.vue?vue&type=script&lang=js&"
import style0 from "./FiltersSwitcherBtn.vue?vue&type=style&index=0&id=7a5596d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5596d0",
  null
  
)

export default component.exports